import { Switch } from "@/components/ui/switch";
import { MESSAGE } from "@/constants/message";
import { cn } from "@/lib/utils";

export type CustomFilterAreaProps = {
  disabled?: boolean;
  checked: boolean;
  onSwitchChange: (checked: boolean) => void;
};

const CustomFilterArea = ({
  disabled,
  checked,
  onSwitchChange
}: CustomFilterAreaProps) => {
  return (
    <div className="flex justify-between items-center gap-2 border border-gainsboro rounded-xl p-2 mb-3">
      <div className={cn("flex flex-col", disabled && "text-light-gray")}>
        <p className="font-semibold text-xs leading-[22px]">
          Custom Filter Area
        </p>
        <span className="text-xs leading-5">
          {MESSAGE.DATASET_ENABLED_DEFINE_ANOTHER_AREA_INPUT}
        </span>
      </div>
      <Switch
        aria-label="switch-custom-filter-area"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onSwitchChange}
      />
    </div>
  );
};

export default CustomFilterArea;
